<section class="child">
    <nav>
        <c-tree-explorer config="shortcutConfig"></c-tree-explorer>
    </nav>
    <div ng-if="!hasRegisters" style="padding:0 10px;"><i class="fa fa-warning" style="padding-right:5px"></i>{{'registers.empty'|translate}}</div>
</section>